// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__x5JQF","products":"SearchPopUp_products__Mv-oJ"};